import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Superseded by the unified dashboard admin page. Kept as a redirect so bookmarks and links out of
 * older emails still land somewhere useful.
 */
export const Route = createFileRoute('/_auth/preferences/insights-dashboard')({
  beforeLoad: () => {
    throw redirect({
      to: '/preferences/dashboards',
      replace: true,
    })
  },
})
